/*
 * Copyright (c) 2025, Gather
 * https://gather.life
 */
'use client';

import { type FunctionComponent } from 'react';
import {
  Page,
  PageContents,
  PageContentsSection,
  PageContentsSpacer,
} from '@marketplace/gather-ui/layouts';

import CatalogVehiclesView from './views/catalog-vehicles.view';
import { FiltersAccordionStateProvider } from './components/filter-accordion-state.provider';

const spacingStyles = { base: 4, sm: 6 };

const CatalogVehiclesPage: FunctionComponent<{
  hydratedWithUserId: string | null;
}> = ({ hydratedWithUserId }) => {
  return (
    <Page>
      <PageContents fullHeight>
        <PageContentsSpacer spacing={spacingStyles} />
        <PageContentsSection fullHeight direction='row'>
          <FiltersAccordionStateProvider>
            <CatalogVehiclesView hydratedWithUserId={hydratedWithUserId} />
          </FiltersAccordionStateProvider>
        </PageContentsSection>
      </PageContents>
    </Page>
  );
};

export default CatalogVehiclesPage;
